// extracted by mini-css-extract-plugin
export default {"vaildColor":"#44cc94","headerconfirmation":"headerconfirmation__3hv8k","headerTitle":"headerTitle__1r0qX","contentContainer":"contentContainer__2_Pg9","headerContainer":"headerContainer__317D5","subHeaderContainer":"subHeaderContainer__DGGye","column":"column__106PJ"};
    if(module.hot) {
      // 1713425484129
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  